import React from 'react'
import {AppPermissions} from "../../types/User";
import {AppPermission} from "./AppPermission";

// Types ----

type AppPermissionsListProps = {
  permissions?: AppPermissions
}

// Component ----

export function AppPermissionsList({permissions}: AppPermissionsListProps) {
  const appPermissions = permissions
    ? Object.entries(permissions)
      .filter(([name]) => name !== 'microphone')
      .sort(([, granted]) => granted ? -1 : 1)
    : [];

  return (
    <>
      {!!appPermissions.length ?
        <div className='flex flex-wrap gap-x-6 gap-y-4'>
          {appPermissions.map(([name, granted]) => <AppPermission key={name} name={name} granted={granted} />)}
        </div> :
        <p className='text-sm text-gray-500'>No data available yet.</p>
      }
    </>
  )
}